import React from "react";
import { type LucideIcon } from "lucide-react";

interface HowItWorksStepProps {
  icon: LucideIcon;
  title: string;
  description: string;
  tagline: string;
  /** Draws the line joining this step to the previous one. Off for the first. */
  showConnector: boolean;
}

const HowItWorksStep: React.FC<HowItWorksStepProps> = ({
  icon: Icon,
  title,
  description,
  tagline,
  showConnector,
}) => (
  <div className="relative flex h-full flex-col gap-4 rounded-[1.125rem] border border-gray-200 bg-white p-8 text-center shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-xl dark:border-slate-700 dark:bg-slate-800">
    {showConnector && (
      <span
        aria-hidden="true"
        className="absolute right-full top-[3.75rem] hidden h-0.5 w-6 bg-primary/25 lg:block"
      />
    )}

    <div className="flex h-11 items-center justify-center text-primary dark:text-primary-light">
      <Icon className="h-9 w-9" strokeWidth={1.8} />
    </div>

    <h3 className="flex items-center justify-center text-lg font-bold leading-tight tracking-tight text-gray-900 dark:text-white lg:min-h-[3em]">
      {title}
    </h3>

    <p className="text-sm leading-relaxed text-gray-500 dark:text-gray-400">
      {description}
    </p>

    <div className="mt-auto pt-3.5 text-sm font-bold italic leading-snug text-primary dark:text-primary-light">
      {tagline}
    </div>
  </div>
);

export default HowItWorksStep;
